import { all, takeLatest } from "redux-saga/effects";
import {
  watcherGetPaymentStatusMessage,
  watcherGetChatConfiguration,
  watcherGetCreateChat,
  watcherGetChatUpdate,
  watcherGetChatMessage,
  watcherGetCreateMessage,
  watcherGetTwilioQuitQueue,
  watcherGetScheduleCallBack,
  watcherGetDisabledTimeLists,
  watcherCreateAppointment,
  watcherGetProfile,
  watcherGetChatReplyStatus,
  watcherConnectLiveChat,
  watcherGetInsiderClientInfoReq,
  watcherSingtelPartnershipLeadsReq,
} from "./policy";
import {
  GET_PAYMENT_STATUS_MESSAGE_REQUEST,
  GET_CHAT_CONFIGURATION,
  GET_CREATE_CHAT,
  GET_CHAT_UPDATE,
  GET_CHAT_MESSAGE,
  GET_CREATE_MESSAGE,
  GET_TWILIO_QUIT_QUEUE,
  GET_SCHEDULE_CALL_BACK,
  GET_DISABLED_TIME_LISTS,
  CREATE_APPOINTMENT,
  GET_PROFILE_LIST_REQUEST,
  GET_CHAT_REPLY_STATUS,
  CONNECT_LIVE_CHAT,
  GET_INSIDER_CLIENT_INFO_REQUEST,
  SINGTEL_PARTNERSHIP_LEADS_REQ,
} from "../actions/policy";
import {
  watcherPostLoginRequest,
  watcherPostConfirmLoginRequest,
  watcherPostForgotUserIdRequest,
  watcherGetCurrentUserIdRequest,
  watcherResendOtpRequest,
  watcherForgotPasswordRequest,
  watcherVerifyForgotPassOtpRequest,
  watcherChangePasswordRequest,
  watcherLoginPortalRequest,
  watcherGetAuthorizationAuth,
  watcherGetAuthToken,
  watcherGetSingPass,
  watcherGetMaintenanceMsg,
  watcherGenerateLoginOtp,
} from "./auth";
import {
  POST_LOGIN_REQUEST,
  POST_CONFIRM_LOGIN_REQUEST,
  POST_FORGOT_USER_ID_REQUEST,
  GET_CURRENT_USER_ID_REQUEST,
  RESEND_OTP_REQUEST,
  FORGOT_PASSWORD_REQUEST,
  VERIFY_FORGOT_PASS_OTP_REQUEST,
  CHANGE_PASSWORD_REQUEST,
  LOGIN_PORTAL_REQUEST,
  GET_AUTHORIZATION_AUTH,
  GET_AUTH_TOKEN_REQUEST,
  GET_SINGPASS,
  GET_MAINTENANCE_MSG,
  GENERATE_LOGIN_OTP,
} from "../actions/auth";
import {
  REGISTRATION_REQUEST,
  REGISTRATION_OTP_REQUEST,
  REGISTRATION_OTP_VERIFY,
  ACTIVATION_GENERIC_LINK_REQUEST,
  ACTIVATION_GENERIC_OTP_VERIFY_REQ,
  ACTIVATION_PERSONAL_LINK_REQ,
  ACTIVATE_PERSONAL_REQ,
  PROMPT_MOBILE_PHONE_INPUT,
  UPDATE_CLIENT_INFO,
  REGISTRATION_OTP_RESEND,
  VALIDATE_MOVIE_REG,
  SUBMIT_MOVIE_REG,
  CALCULATE_WALKWAG_AMOUNT_REQ,
  CHECK_PAYNOW_QR_STATUS_REQ,
  SUBMIT_CAMPAIGN_FORM_REQ,
  GET_REGISTRATION_CUSTOMER_DETAILS,
  REGISTER_CUSTOMER,
  GET_REGISTRATION_CUSTOMER_INFO,
  GET_LOGIN_TOKEN,
  GENERATE_OTP_ONBOARDING,
  REGISTER_NEW_CUSTOMERV2,
  LOG_REGISTRATION_REQUEST,
  VALIDATION_REGISTRATION,
  UPLOAD_OCR_NRIC,
  UPDATE_CLIENT_INFOV4_REQUEST,
} from "../actions/registration";
import {
  watcherRegistrationRequest,
  watcherRegistrationOTPRequest,
  watcherRegistrationOTPVerify,
  watcherActivationGenericLinkReq,
  watcherActivationGenericOtpVerify,
  watcherActivationPersonalLinkReq,
  watcherActivatePersonalReq,
  watcherPromptMobilePhoneInput,
  watcherUpdateClientInfo,
  watcherRegistrationResendOTP,
  watcherValidateMovieReg,
  watcherSubmitMovieReg,
  watcherCalculateWalkWagAmountReq,
  watcherCheckPayNowQRStatusReq,
  watcherSubmitCampaignFormReq,
  watcherGetRegistrationCustomerDetails,
  watcherRegisterNewCustomer,
  watcherGetRegistrationCustomerInfo,
  watcherGetLoginToken,
  watcherGenerateOTPOnboarding,
  watcherRegisterNewCustomerv2,
  watcherLogRegistrationRequest,
  watcherValidateRegistration,
  watcherUploadOcrNric,
  watcherUpdateClientInfov4Request,
} from "./registration";
import {
  watcherCheckRenewability,
  watcherRenewalPayNow,
  watcherGetStatusMessage,
  watcherRenewalTiqHome,
} from "./onlineRenewal";
import {
  CHECK_RENEWABILITY,
  RENEWAL_PAY_NOW,
  GET_STATUS_MESSAGE,
  RENEWAL_TIQ_HOME,
} from "../actions/onlineRenewal";
import {
  watcherGetDDAPolicy,
  watcherCreateEDDA,
  watcherGetGIROBankList,
  watcherGetGIROCallBackData,
  watcherGetGiroCallBackExist,
  watcherSubmitGiro,
  watcherGetGiroSubmitCallBackExist,
  watcherEnroleGiro,
  watcherConfirmPayEddaGiRenewal,
} from "./enrolGIRONow";
import {
  GET_DDA_POLICY,
  CREATE_EDDA,
  GET_GIRO_BANK_LIST,
  GET_GIRO_CALL_BACK_DATA,
  SUBMIT_GIRO_DATA,
  GET_GIRO_CALL_BACK_EXIST,
  GET_GIRO_SUBMIT_CALL_BACK_EXIST,
  ENROL_EGIRO,
  CONFIRM_PAY_EDDA_GI_RENEWAL,
} from "../actions/enrolGIRONow";
import {
  watcherGetTwilioGetFileStatus,
  watcherGetTwilioRequestOTP,
  watcherGetTwilioGetFile,
} from "./twilio";
import {
  GET_TWILIO_GET_FILE_STATUS,
  GET_TWILIO_REQUEST_OTP,
  GET_TWILIO_GET_FILE,
} from "../actions/twilio";

function* rootSaga() {
  yield all([
    //post saga
    yield takeLatest(
      GET_PAYMENT_STATUS_MESSAGE_REQUEST,
      watcherGetPaymentStatusMessage
    ),
    yield takeLatest(POST_LOGIN_REQUEST, watcherPostLoginRequest),
    yield takeLatest(
      POST_CONFIRM_LOGIN_REQUEST,
      watcherPostConfirmLoginRequest
    ),
    yield takeLatest(
      POST_FORGOT_USER_ID_REQUEST,
      watcherPostForgotUserIdRequest
    ),
    yield takeLatest(
      GET_CURRENT_USER_ID_REQUEST,
      watcherGetCurrentUserIdRequest
    ),
    yield takeLatest(RESEND_OTP_REQUEST, watcherResendOtpRequest),
    yield takeLatest(FORGOT_PASSWORD_REQUEST, watcherForgotPasswordRequest),
    yield takeLatest(
      VERIFY_FORGOT_PASS_OTP_REQUEST,
      watcherVerifyForgotPassOtpRequest
    ),
    yield takeLatest(CHANGE_PASSWORD_REQUEST, watcherChangePasswordRequest),
    yield takeLatest(REGISTRATION_REQUEST, watcherRegistrationRequest),
    yield takeLatest(REGISTRATION_OTP_REQUEST, watcherRegistrationOTPRequest),
    yield takeLatest(REGISTRATION_OTP_VERIFY, watcherRegistrationOTPVerify),
    yield takeLatest(LOGIN_PORTAL_REQUEST, watcherLoginPortalRequest),
    yield takeLatest(GET_AUTHORIZATION_AUTH, watcherGetAuthorizationAuth),
    yield takeLatest(GET_AUTH_TOKEN_REQUEST, watcherGetAuthToken),
    yield takeLatest(
      ACTIVATION_GENERIC_LINK_REQUEST,
      watcherActivationGenericLinkReq
    ),
    yield takeLatest(
      ACTIVATION_GENERIC_OTP_VERIFY_REQ,
      watcherActivationGenericOtpVerify
    ),
    yield takeLatest(
      ACTIVATION_PERSONAL_LINK_REQ,
      watcherActivationPersonalLinkReq
    ),
    yield takeLatest(ACTIVATE_PERSONAL_REQ, watcherActivatePersonalReq),
    yield takeLatest(CHECK_RENEWABILITY, watcherCheckRenewability),
    yield takeLatest(RENEWAL_PAY_NOW, watcherRenewalPayNow),
    yield takeLatest(GET_STATUS_MESSAGE, watcherGetStatusMessage),
    yield takeLatest(PROMPT_MOBILE_PHONE_INPUT, watcherPromptMobilePhoneInput),
    yield takeLatest(UPDATE_CLIENT_INFO, watcherUpdateClientInfo),
    yield takeLatest(GET_SINGPASS, watcherGetSingPass),
    yield takeLatest(REGISTRATION_OTP_RESEND, watcherRegistrationResendOTP),
    yield takeLatest(RENEWAL_TIQ_HOME, watcherRenewalTiqHome),
    yield takeLatest(GET_DDA_POLICY, watcherGetDDAPolicy),
    yield takeLatest(CREATE_EDDA, watcherCreateEDDA),
    yield takeLatest(GET_GIRO_BANK_LIST, watcherGetGIROBankList),
    yield takeLatest(GET_GIRO_CALL_BACK_DATA, watcherGetGIROCallBackData),
    yield takeLatest(SUBMIT_GIRO_DATA, watcherSubmitGiro),
    yield takeLatest(
      GET_GIRO_SUBMIT_CALL_BACK_EXIST,
      watcherGetGiroSubmitCallBackExist
    ),
    yield takeLatest(GET_GIRO_CALL_BACK_EXIST, watcherGetGiroCallBackExist),
    yield takeLatest(GET_TWILIO_GET_FILE_STATUS, watcherGetTwilioGetFileStatus),
    yield takeLatest(GET_TWILIO_REQUEST_OTP, watcherGetTwilioRequestOTP),
    yield takeLatest(GET_TWILIO_GET_FILE, watcherGetTwilioGetFile),
    yield takeLatest(ENROL_EGIRO, watcherEnroleGiro),

    yield takeLatest(GET_CHAT_CONFIGURATION, watcherGetChatConfiguration),
    yield takeLatest(GET_CREATE_CHAT, watcherGetCreateChat),
    yield takeLatest(GET_CHAT_UPDATE, watcherGetChatUpdate),
    yield takeLatest(GET_CHAT_MESSAGE, watcherGetChatMessage),
    yield takeLatest(GET_CREATE_MESSAGE, watcherGetCreateMessage),
    yield takeLatest(GET_TWILIO_QUIT_QUEUE, watcherGetTwilioQuitQueue),

    yield takeLatest(GET_SCHEDULE_CALL_BACK, watcherGetScheduleCallBack),
    yield takeLatest(GET_DISABLED_TIME_LISTS, watcherGetDisabledTimeLists),
    yield takeLatest(CREATE_APPOINTMENT, watcherCreateAppointment),

    yield takeLatest(VALIDATE_MOVIE_REG, watcherValidateMovieReg),
    yield takeLatest(SUBMIT_MOVIE_REG, watcherSubmitMovieReg),

    yield takeLatest(CONFIRM_PAY_EDDA_GI_RENEWAL, watcherConfirmPayEddaGiRenewal),

    yield takeLatest(GET_MAINTENANCE_MSG, watcherGetMaintenanceMsg),
    yield takeLatest(GET_PROFILE_LIST_REQUEST, watcherGetProfile),
    yield takeLatest(GET_CHAT_REPLY_STATUS, watcherGetChatReplyStatus),
    yield takeLatest(CONNECT_LIVE_CHAT, watcherConnectLiveChat),
    yield takeLatest(GET_INSIDER_CLIENT_INFO_REQUEST, watcherGetInsiderClientInfoReq),

    yield takeLatest(SINGTEL_PARTNERSHIP_LEADS_REQ, watcherSingtelPartnershipLeadsReq),

    yield takeLatest(SUBMIT_CAMPAIGN_FORM_REQ, watcherSubmitCampaignFormReq),
    yield takeLatest(CALCULATE_WALKWAG_AMOUNT_REQ, watcherCalculateWalkWagAmountReq),
    yield takeLatest(CHECK_PAYNOW_QR_STATUS_REQ, watcherCheckPayNowQRStatusReq), 

    yield takeLatest(GET_REGISTRATION_CUSTOMER_DETAILS, watcherGetRegistrationCustomerDetails), 
    yield takeLatest(REGISTER_CUSTOMER, watcherRegisterNewCustomer), 

    //revamp2.0
    yield takeLatest(GET_REGISTRATION_CUSTOMER_INFO, watcherGetRegistrationCustomerInfo), 
    yield takeLatest(GET_LOGIN_TOKEN, watcherGetLoginToken), 
    yield takeLatest(GENERATE_OTP_ONBOARDING, watcherGenerateOTPOnboarding), 
    yield takeLatest(REGISTER_NEW_CUSTOMERV2, watcherRegisterNewCustomerv2), 
    yield takeLatest(LOG_REGISTRATION_REQUEST, watcherLogRegistrationRequest),
    yield takeLatest(VALIDATION_REGISTRATION, watcherValidateRegistration), 
    yield takeLatest(UPLOAD_OCR_NRIC, watcherUploadOcrNric),  
    yield takeLatest(UPDATE_CLIENT_INFOV4_REQUEST, watcherUpdateClientInfov4Request),
    yield takeLatest(GENERATE_LOGIN_OTP, watcherGenerateLoginOtp),  
  ]);
}

export default rootSaga;
